import { render, staticRenderFns } from "./RO.vue?vue&type=template&id=4bf54a97&scoped=true&"
import script from "./RO.vue?vue&type=script&lang=js&"
export * from "./RO.vue?vue&type=script&lang=js&"
import style0 from "./RO.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RO.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./RO.vue?vue&type=style&index=2&id=4bf54a97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf54a97",
  null
  
)

export default component.exports